import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {ClientService} from "../../../service/client.service";
import {EnumEtats} from "../../../enum/enum.etat";
import {OrdonnanceService} from "../../../service/ordonnance.service";

@Component({
  selector: 'app-sms-client',
  templateUrl: './sms-client.component.html',
  styleUrls: ['./sms-client.component.scss']
})
export class SmsClientComponent implements OnInit {

  @Input()
  sendFormEvent: Observable<void>;
  private sendFormEventSubscription: Subscription;

  @Input()
  public message: string = "";
  public copyMail = false;


  @Output()
  private modalSMS: EventEmitter<boolean> = new EventEmitter();

  public smsClientForm: FormGroup;
  public submitted = false;
  buttonDisabled: boolean = false;

  protected displayError = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    protected clientService: ClientService,
  ) { }

  ngOnInit(): void {
    this.smsClientForm = this.formBuilder.group({
      message: this.formBuilder.control(this.message, [Validators.required]),
      copyMail: this.formBuilder.control(this.copyMail),
    });

    //this.sendFormEventSubscription = this.sendFormEvent.subscribe(() => this.onSubmit());
    this.modalSMS.emit(true);
  }

  ngOnDestroy() {
    //this.sendFormEventSubscription.unsubscribe();
  }

  get field() {
    return this.smsClientForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.smsClientForm.invalid) {
      return;
    }
    this.sendSMSToClient();
  }


  formSended($event: any) {
    this.closeModal();
    this.buttonDisabled = false;
  }

  sendForm() {
    this.buttonDisabled = true;
    this.onSubmit();
    //this.sendFormSubject.next();
  }

  closeModal() {
    this.modalSMS.emit(false);
  }

  sendSMSToClient() {
    this.clientService.sendSMSToClient(this.smsClientForm.value.message).subscribe(
      data => { this.toastr.success("Le sms a été bien envoyé."); },
      err => { this.toastr.error("Une erreur est survenue."); },
      () => { this.formSended(true); }
    );
  }

}
